import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Smart redirect component for root path (/).
 * Checks localStorage for admin return URL before redirecting to chat.
 * Uses localStorage (not sessionStorage) to survive the MSAL redirect flow.
 */
const RootRedirect: React.FC = () => {
  // Check localStorage SYNCHRONOUSLY during render (before any effects run)
  const adminReturnUrl = localStorage.getItem('adminReturnUrl');
  
  // Clean up localStorage AFTER navigation (in effect, not during render)
  useEffect(() => {
    if (adminReturnUrl && adminReturnUrl.startsWith('/admin')) {
      console.log('RootRedirect: Cleaning up adminReturnUrl after redirect');
      localStorage.removeItem('adminReturnUrl');
    }
  }, [adminReturnUrl]);
  
  if (adminReturnUrl && adminReturnUrl.startsWith('/admin')) {
    return <Navigate to={adminReturnUrl} replace />;
  }

  return <Navigate to="/chat" replace />;
};

export default RootRedirect;
